// extracted by mini-css-extract-plugin
export var active = "FooterCta-module--active--784ce";
export var alt = "FooterCta-module--alt--225af";
export var container = "FooterCta-module--container--eba33";
export var desktopOnly = "FooterCta-module--desktopOnly--b3980";
export var main = "FooterCta-module--main--b977b";
export var mobileOnly = "FooterCta-module--mobileOnly--ae7de";
export var textLeft = "FooterCta-module--textLeft--79488";
export var visuallyHidden = "FooterCta-module--visuallyHidden--34cdd";